export function dateFormatter(date) {
    return new Date(date).toLocaleDateString("en-us", {year: 'numeric', month: 'long', day: 'numeric'});
}

export function dateTimeLocaleFormatter(date) {
    return new Date(date).toLocaleString();
}